import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export type ThemeName = 'arcade' | 'brand';

/** Player surfaces are dark; business surfaces are light (PART I). */
export function themeForPath(pathname: string): ThemeName {
  return pathname.startsWith('/screen') || pathname.startsWith('/j/') ? 'arcade' : 'brand';
}

/** Sets data-theme on <html>; every token in tokens.css keys off it. */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const theme = themeForPath(pathname);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return <>{children}</>;
}
